import { render, staticRenderFns } from "./sidePanel.vue?vue&type=template&id=5479caae&"
import script from "./sidePanel.vue?vue&type=script&lang=js&"
export * from "./sidePanel.vue?vue&type=script&lang=js&"
import style0 from "./sidePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports